/**
 * Enum loại hóa đơn
 * PQDat 02.08.2022
 */
export default {
  /**
   * Hóa đơn thay thế
   */
  Replacement: 3,

  /**
   * Hóa đơn điều chỉnh
   * vqphong - 06/10/2022
   */
  AdjustmentSaleInvoice: 5,
  
  // hóa đơn đã bị thay thế
  SaleInvoiceReplaced: 7,

  // hóa đơn đã bị điều chỉnh
  SaleInvoiceAdjustmented: 8,
};
